import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import LogoutIcon from '../assets/Logout.svg';
import BrandWordmark from './BrandWordmark';
import PoweredByTrAingle from './PoweredByTrAingle';

function Header({ user, handleLogout, theme = 'dark', toggleTheme, usage }) {
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();
  const isDark = theme === 'dark';
  
  // Extract user display name and profile picture
  const getDisplayName = () => {
    if (!user) return 'Guest Session';
    
    if (user.first_name && user.last_name) {
      // Ensure they are strings
      const firstName = String(user.first_name);
      const lastName = String(user.last_name);
      return `${firstName} ${lastName}`;
    } else if (user.name && typeof user.name === 'string') {
      return user.name;
    } else if (user.login && typeof user.login === 'string') {
      return user.login.split('@')[0];
    }
    return 'User';
  };

  const profilePicture = user?.picture || null;

  React.useEffect(() => {
    setImageError(false);
  }, [profilePicture]);

  const handleLogoClick = () => navigate('/');

  return (
    <header className="app-header">
      <button className="app-brand" onClick={handleLogoClick} type="button">
        <span className="app-brand-lockup">
          <BrandWordmark className="app-brand-mark" />
          <PoweredByTrAingle className="app-powered-by" />
        </span>
      </button>
      <div className="user-info">
        {usage ? (
          <div className="usage-badge" title={usage.unlimited ? 'Unlimited redactions' : `${usage.remaining} free redactions left`}>
            {usage.unlimited ? 'Pro plan' : usage.is_guest ? `Guest ${usage.used}/${usage.limit}` : `${usage.used}/${usage.limit} used`}
          </div>
        ) : null}
        {toggleTheme ? (
          <button
            className="theme-toggle-btn app-theme-toggle"
            type="button"
            onClick={toggleTheme}
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
          >
            {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
          </button>
        ) : null}
        <div className="user-profile">
          {profilePicture && !imageError ? (
            <div className="profile-picture">
              <img 
                src={profilePicture} 
                alt="Profile"
                onLoad={() => setImageError(false)}
                onError={() => setImageError(true)}
              />
            </div>
          ) : (
            <div className="profile-picture profile-fallback">
              <span className="profile-fallback-text">
                {getDisplayName().split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}
              </span>
            </div>
          )}
          <span className="app-user-greeting">Welcome, {getDisplayName()}</span>
        </div>
        {user ? (
          <button className="app-logout-btn" type="button" onClick={handleLogout} aria-label="Log out">
            <img src={LogoutIcon} alt="" />
          </button>
        ) : null}
      </div>
    </header>
  );
}

export default Header; 
